import api from '../../../services/api';
import { normalizePurchaseInvoiceDraft } from '../../../dto/workflowInvoice';
import { normalizeSupplierOrderDelivery } from '../../../dto/supplierOrderDelivery';
export async function fetchSupplierOrderDelivery(id: string) {
  const response = await api.get(`/supplier-orders/${encodeURIComponent(id)}/delivery-progress`);
  return normalizeSupplierOrderDelivery(response.data);
}

export async function fetchDeliveryInvoicePrefill(id: string, transportId: string) {
  const response = await api.get(`/supplier-orders/${encodeURIComponent(id)}/deliveries/${encodeURIComponent(transportId)}/invoice-prefill`);
  const draft = normalizePurchaseInvoiceDraft(response.data);
  return { ...draft, lines: draft.lines.map(line => ({ ...line, key: `delivery:${line.sourceOrderLineId}` })) };
}
